<template>
  <v-dialog
    v-model="alwaysOpen"
    :fullscreen="isMobile"
    width="80%"
    max-width="512px"
    @click:outside="close"
    @keydown.esc="close"
  >
    <v-card class="form-dialog form-dialog--new-user">
      <v-icon
        class="form-dialog__button form-dialog__button--close"
        @click="close"
      >
        mdi-close
      </v-icon>

      <h1 class="form-dialog__title">Connect to HUB</h1>
      <span class="form-dialog__subtitle">
            A copy of ach visitor parking transaction in this location will be sent to the HUB.
      </span>
      <v-form class="mt-8">
        <v-row dense>
          <v-col cols="12" style="height: 34px">
            <v-autocomplete
            v-model="selectedHub"
            class="form-font pkmn-input"
            background-color="#F6F6F6"
            label="Select from list"
            item-text="name"
            item-value="id"
            :items="filteredItems"
            :search-input.sync="search"
            placeholder="Choose HUB"
            clearable
            solo
            flat
            dense
          >
      </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" style="height: 28px"></v-col>
      </v-row>
        <v-row dense>
          <v-col cols="12" style="height: 34px">
            <v-text-field
                ref="amountAdded"
                solo
                flat
                dense
                background-color="#F6F6F6"
                label="HUB code"
                v-model="code"
                class="pkmn-input"
                :rules="[rules.required]"
              >
              </v-text-field>
          </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" style="height: 44px"></v-col>
      </v-row>
        <v-row class="form-dialog__button-wrap">
        <v-col cols="6">
          <v-btn class="pkmn-button" outlined color="primary" @click="close">
            Cancel
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn
            class="pkmn-button pkmn-button--confirm pkmn-button--has-border"
            color="primary"
            @click="add"
            :disabled="selectedHub === null || code === null || code === ''"
          >
            Add
          </v-btn>
        </v-col>
      </v-row>
      </v-form>

    </v-card>
  </v-dialog>
</template>

<script>
import dropdownNarrow from '@/assets/dropdown_arrow.svg'
import rules from '@/helpers/validation'

export default {
  name: 'FormAddHubPopup',
  props: {
      hubList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      alwaysOpen: true,
      selectedHub: null,
      dropdownNarrow,
      search: null,
      code: null,
      rules: {
        ...rules
      }
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth <= this.mobileBreakpoint
    },
    filteredItems() {
      if (!this.search) return this.hubList;
      return this.hubList.filter(item => 
        item.toLowerCase().includes(this.search.toLowerCase())
      );
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    resetForm() {
      this.search = null;
      this.selectedHub = null;
    },
    add() {
      const record = {hub_location_code: this.code, hub_name: this.selectedHub}
      this.$emit('add', record)
    }
  }
}
</script>
<style lang="scss">
@import '@/style/common';

.v-text-field__details {
  padding: 0px !important;
}

.col:has(.v-input--is-focused) {
  .text-input-label {
    color: $color-brand;
  }
}

.warden-picker {
  padding: 24px
}
.form-dialog--new-user .v-input--is-focused .v-input__slot {
  border: 1px solid $color-brand !important;
}

.form-dialog--new-user .v-input.error--text .v-input__slot {
  border: 1px solid $color-danger !important;
}

.my-text-field ::v-deep .v-text-field__details .v-messages {
  display: flex;
  justify-content: flex-end;
}
</style>
